import { createContainer } from 'react-sweet-state';

import {
  ACTIONS,
  type Actions,
  type ContainerProps,
  MultiPromptTemplatesStore,
  type State,
} from './MultiPromptTemplatesStore';

export const MultiPromptTemplatesContainer = createContainer<State, Actions, ContainerProps>(
  MultiPromptTemplatesStore,
  {
    onInit:
      () =>
      ({ setState, dispatch }, { state, currentCustomerId, currentWorkspaceId }) => {
        dispatch(ACTIONS.init(currentCustomerId, currentWorkspaceId));
        if (state) {
          setState(state);
        }
      },
    onUpdate:
      () =>
      ({ setState, dispatch }, { state, currentCustomerId, currentWorkspaceId }) => {
        dispatch(ACTIONS.update(currentCustomerId, currentWorkspaceId));
        if (state) {
          setState(state);
        }
      },
  }
);
